
export default {
  props: {
    document: {
      type: Object,
      default: () => {}
    }
  }
}
